import { render } from "./ProductsIndexTable.vue?vue&type=template&id=65311fea"
import script from "./ProductsIndexTable.vue?vue&type=script&lang=js"
export * from "./ProductsIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__